module.exports = __webpack_public_path__ + "img/creator.bc91d08d.webp";